import Vue from "vue";
import * as VueGoogleMaps from 'gmap-vue'

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDmWCGBpd8anb_J0gk6Q3ilwAHyOfeT9Sw',
        libraries: 'drawing'
    }
})

Vue.component('ground-overlay', VueGoogleMaps.MapElementFactory({
    mappedProps: {
        'opacity': {}
    },
    props: {
        'source': { type: String },
        'bounds': { type: Object }
    },
    events: ['click', 'dblclick'],
    name: 'groundOverlay',
    ctr: () => window.google.maps.GroundOverlay,
    ctrArgs: (options, { source, bounds }) => [source, bounds, options]
}))

export default VueGoogleMaps